import "./AddRecordBatchStep2.css";
interface AddRecordBatchStep2Props {
  validationErrors: string[];
}

const AddRecordBatchStep2: React.FC<AddRecordBatchStep2Props> = (props) => {
  return (
    <>
      <div className="validation-area step-area">
        <ul>
          {props.validationErrors.map((error, index) => (
            <li key={index}>{error}</li>
          ))}
        </ul>
      </div>
    </>
  );
};

export default AddRecordBatchStep2;
